import { CardTableExpandableHeader } from './../../models/card-table-expandable-header';
import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableOptions } from '../../models/card-table-options.model';
import { NavigationService } from '@huge-monorepo/portal/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-table-row',
  templateUrl: './card-table-row.component.html',
  styleUrls: ['./card-table-row.component.scss'],
})
export class CardTableRowComponent implements OnInit, OnChanges, OnDestroy {
  @Input() prefixTemplate: TemplateRef<any>;
  @ViewChild('prefix') prefix: TemplateRef<any>;

  @Input() cardTemplate: TemplateRef<any>;
  @ViewChild('cardContent') cardContent: TemplateRef<any>;
  @Input() isExpandable = false;
  @Input() rowTemplate: TemplateRef<any>;
  @ViewChild('rowContent') rowContent: TemplateRef<any>;

  @Input() affixTemplate: TemplateRef<any>;
  @ViewChild('affix') affix: TemplateRef<any>;

  @Input() row: any;
  @Input() headers: any;
  @Input() options: CardTableOptions;
  @Input() breakpoint: ScreenSize;
  @Input() dropDownActionsTemplate: TemplateRef<any>;
  @Input() isSelected: boolean = false;

  @Input() dropDownDataKey = '';
  @Input() expansionHeader: Array<CardTableExpandableHeader> = [];
  @Input() originalStyling: boolean = true;
  @Output() selectedEvent = new EventEmitter<any>();
  @Output() selectDropDownActionEvent = new EventEmitter<any>();
  objectKeys = Object.keys;

  isSideNavCollapsed: boolean = false;
  sub: Subscription;

  singleClickTimer: any;
  mouseDownTimer: Date;

  constructor(public layoutService: LayoutService, private navigationService: NavigationService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['row']) {

    }
    if (changes['isSelected']) {
      this.isSelected = changes['isSelected'].currentValue;
    }
  }

  ngOnInit(): void {
    if (this.row && this.row.$implicit) {
      this.isSelected = this.row.$implicit[this.options.selectedProperty];
    }
    this.isSideNavCollapsed = this.navigationService.GetIsCollapsed();
    this.sub = this.navigationService.isCollapsed.subscribe((isCollapsed) => {
      this.isSideNavCollapsed = isCollapsed;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  selected(): void {
    if (this.options.isSelectable) {
      this.isSelected = !this.isSelected;
    }
    this.selectedEvent.emit(this.row);
  }

  configureTooltip(header, property) {
    const status = property.value.status ? 'Online' : 'Offline';
    const lastSeen = property.value.lastSeen ? property.value.lastSeen : 'N/A'
    return `${header.TooltipText}: ${status}
    Updated: ${lastSeen}`;
  }

  handleRowItemClick(header: any) {
    if (this.singleClickTimer) {
      //If Double Click Copy number
      clearTimeout(this.singleClickTimer);
      this.singleClickTimer = null;
      if (header.OnDoubleClick != null) {
        header.OnDoubleClick(this.row.$implicit);
      }
    } else {
      this.singleClickTimer = setTimeout(() => {
        //If single click do something
        this.singleClickTimer = null;
        if (new Date().getTime() - this.mouseDownTimer.getTime() > 500) {
          //On drag do nothing
          return;
        }
        if (header?.OnClick != null) {
          header.OnClick(this.row.$implicit);
        }
      }, 250);
    }
  }

  mouseDown() {
    this.mouseDownTimer = new Date();
  }
}
